import Vue from "vue";
import App from "./App.vue";
import ba from "vue-ba";
import router from "./router";
import store from "./store";
import vants from "./vant";
import "lib-flexible/flexible.js";
import "@/assets/style/common.sass";
import "@/assets/style/icon.scss";
import "@/assets/style/vant.scss";

Vue.use(vants);

Vue.config.productionTip = false;

Vue.use(ba, { siteId: "5d54724331db54067bbc12e295b12249" });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面
// router.onError((error) => {
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   // const targetPath = router.history.pending.fullPath;
//   if (isChunkLoadFailed) {
//     // 用路由的replace方法，
//     // 并没有相当于F5刷新页面，
//     // 失败的js文件并没有从新请求，
//     // 会导致一直尝试replace页面导致死循环，
//     // 而用 location.reload 方法，相当于触发F5刷新页面，
//     // 虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，
//     // 从而曲线救国解决该问题
//     window.location.reload();
//     // router.replace(targetPath);
//   } else {
//     console.log("no");
//   }
// });

// router.beforeEach((to, from, next) => {
//   console.log("全局钩子",to, from)
//   setTimeout(() => {
//     var _hmt = _hmt || [];
//     (function () {
//       var hm = document.createElement("script");
//       hm.src = "https://hm.baidu.com/hm.js?5d54724331db54067bbc12e295b12249";
//       var s = document.getElementsByTagName("script")[0];
//       s.parentNode.insertBefore(hm, s);
//     })();
//   }, 0);
//   next();
// })
